const contactsCache = new Map();
const CONTACTS_CACHE_MAX_AGE_MS = 5 * 60 * 1000;

const getContactsCacheKey = ({ searchParam = "", pageNumber = 1 }) =>
  JSON.stringify({ searchParam, pageNumber });

const getCachedContacts = params => {
  const key = getContactsCacheKey(params);
  const cached = contactsCache.get(key);

  if (!cached || Date.now() - cached.updatedAt > CONTACTS_CACHE_MAX_AGE_MS) {
    contactsCache.delete(key);
    return null;
  }

  return cached;
};

const setCachedContacts = (params, data) => {
  contactsCache.set(getContactsCacheKey(params), {
    contacts: data.contacts,
    count: data.count,
    hasMore: data.hasMore,
    updatedAt: Date.now(),
  });
};

const updateCachedContact = contact => {
  contactsCache.forEach((cached, key) => {
    const { searchParam, pageNumber } = JSON.parse(key);
    const normalizedSearch = searchParam.trim().toLowerCase();
    const matchesSearch =
      !normalizedSearch ||
      (contact.name || "").toLowerCase().includes(normalizedSearch) ||
      (contact.number || "").toLowerCase().includes(normalizedSearch);
    const index = cached.contacts.findIndex(item => item.id === contact.id);

    if (index !== -1) {
      cached.contacts = matchesSearch
        ? cached.contacts.map(item => item.id === contact.id ? contact : item)
        : cached.contacts.filter(item => item.id !== contact.id);
    } else if (pageNumber === 1 && matchesSearch) {
      cached.contacts = [...cached.contacts, contact]
        .sort((left, right) => (left.name || "").localeCompare(right.name || ""))
        .slice(0, 20);
      cached.count += 1;
    }

    cached.updatedAt = Date.now();
  });
};

const deleteCachedContact = contactId => {
  contactsCache.forEach(cached => {
    if (!cached.contacts.some(contact => contact.id === contactId)) return;

    cached.contacts = cached.contacts.filter(contact => contact.id !== contactId);
    cached.count = Math.max(0, cached.count - 1);
    cached.updatedAt = Date.now();
  });
};

const clearContactsCache = () => {
  contactsCache.clear();
};

export {
  clearContactsCache,
  deleteCachedContact,
  getCachedContacts,
  setCachedContacts,
  updateCachedContact,
};
